export const bubble = {
    id: 'bubble',
    width: 208,
    height: 104,
    d: 'M155.055 0H52.9455C23.7045 0 0 23.2812 0 52C0 80.7188 23.7045 104 52.9455 104H155.055C184.296 104 208 80.7188 208 52C208 23.2812 184.296 0 155.055 0Z',
};
